export class Lead {
  constructor({
    _id = null,
    firstName = "",
    lastName = "",
    email = "",
    description = "",
    currentStatus = {
      name: "",
      color: "",
      id: 0,
    },
    mobile = "",
    alternateNumber = "",
    probability = "",
    productCategory = "",
    productInterested = {
      name: "",
      id: null,
      _id: "",
    },
    ofCompany = "",
    assignedTo = "",
    mannualForm = true,
    textMessageAboutActivity = "",
    address = {
      street: "",
      city: "",
      state: "",
      zipcode: "",
    },
    leadSource = "User Create",
    referenceSource = "",
    leadType = "",
    clientCode = "",
    businessType = "B2C",
    occupation = "",
    language = "",
    city = "",
    state = "",
    timeline = {},
    referenceByFranchiseCode = "",
    referenceByFranchiseMobile = "",
    referenceByFranchiseEmail = "",
    referenceByFranchiseName = "",
    franchiseDetails = "",
    franchiseRM = "",
    question1 = "",
    question2 = "",
    question3 = "",
    meetingStatus = "",
    callHistoryRemarks = [],
    utmMedium = "",
    utmSource = "",
    utmContent = "",
    utmTerm = "",
    utmCampaign = "",
    dataSources = "",
    ipAddress = "",
    adAccount = "",
    adCampaign = "",
    adSet = "",
    ads = "",
    leadForm = "",
    facebookPage = "",
    adAccountId = "",
    adCampaignId = "",
    adSetId = "",
    adId = "",
    leadFormId = "",
    facebookPageId = "",
    brand = "",
    leadIdSocial = "",
    businessLeadType = "",
    platform = "",
    campaignName = "",
    adsName = "",
  } = {}) {
    this._id = _id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.description = description;
    this.currentStatus = currentStatus;
    this.mobile = mobile;
    this.alternateNumber = alternateNumber;
    this.probability = probability;
    this.productCategory = productCategory;
    this.productInterested = productInterested;
    this.ofCompany = ofCompany;
    this.assignedTo = assignedTo;
    this.mannualForm = mannualForm;
    this.textMessageAboutActivity = textMessageAboutActivity;
    this.address = address;
    this.leadSource = leadSource;
    this.referenceSource = referenceSource;
    this.leadType = leadType;
    this.clientCode = clientCode;
    this.businessType = businessType;
    this.occupation = occupation;
    this.language = language;
    this.city = city;
    this.state = state;
    this.timeline = timeline;
    this.referenceByFranchiseCode = referenceByFranchiseCode;
    this.referenceByFranchiseMobile = referenceByFranchiseMobile;
    this.referenceByFranchiseEmail = referenceByFranchiseEmail;
    this.referenceByFranchiseName = referenceByFranchiseName;
    this.franchiseDetails = franchiseDetails;
    this.franchiseRM = franchiseRM;
    this.question1 = question1;
    this.question2 = question2;
    this.question3 = question3;
    this.meetingStatus = meetingStatus;
    this.callHistoryRemarks = callHistoryRemarks;
    this.utmMedium = utmMedium;
    this.utmSource = utmSource;
    this.utmContent = utmContent;
    this.utmTerm = utmTerm;
    this.utmCampaign = utmCampaign;
    this.dataSources = dataSources;
    this.ipAddress = ipAddress;
    this.adAccount = adAccount;
    this.adCampaign = adCampaign;
    this.adSet = adSet;
    this.ads = ads;
    this.leadForm = leadForm;
    this.facebookPage = facebookPage;
    this.adAccountId = adAccountId;
    this.adCampaignId = adCampaignId;
    this.adSetId = adSetId;
    this.adId = adId;
    this.leadFormId = leadFormId;
    this.facebookPageId = facebookPageId;
    this.brand = brand;
    this.leadIdSocial = leadIdSocial;
    this.businessLeadType = businessLeadType;
    this.platform = platform;
    this.campaignName = campaignName;
    this.adsName = adsName;
  }

  static fromApiResponse(data) {
    return new Lead({
      _id: data._id || null,
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      email: data.email || "",
      leadSource: data.leadSource || "",
      description: data.description || "",
      currentStatus: data.currentStatus || { name: "", color: "", id: null },
      mobile: data.mobile || "",
      alternateNumber: data.alternateNumber || "",
      probability: data.probability || "",
      productCategory: data.productCategory || "",
      productInterested: data.productInterested || {
        name: "",
        id: null,
        _id: "",
      },
      ofCompany: data.ofCompany || "",
      assignedTo: data.assignedTo || "",
      textMessageAboutActivity: data.textMessageAboutActivity || "",
      address: data.address || { street: "", city: "", state: "", zipcode: "" },
      referenceSource: data.referenceSource || "",
      leadType: data.leadType || "",
      clientCode: data.clientCode || "",
      businessType: data.businessType || "B2C",
      occupation: data.occupation || "",
      language: data.language || "",
      city: data.city || "",
      state: data.state || "",
      timeline: data.timeline || {},
      referenceByFranchiseCode: data.referenceByFranchiseCode || "",
      referenceByFranchiseMobile: data.referenceByFranchiseMobile || "",
      referenceByFranchiseEmail: data.referenceByFranchiseEmail || "",
      referenceByFranchiseName: data.referenceByFranchiseName || "",
      franchiseDetails: data.franchiseDetails || "",
      franchiseRM: data.franchiseRM || "",
      question1: data.question1 || "",
      question2: data.question2 || "",
      question3: data.question3 || "",
      meetingStatus: data.meetingStatus || "",
      callHistoryRemarks: data.callHistoryRemarks || [],
      utmMedium: data.utmMedium,
      utmSource: data.utmSource,
      utmContent: data.utmContent,
      utmTerm: data.utmTerm,
      utmCampaign: data.utmCampaign,
      dataSources: data.dataSources,
      ipAddress: data.ipAddress,
      adAccount: data.adAccount,
      adCampaign: data.adCampaign,
      adSet: data.adSet,
      ads: data.ads,
      leadForm: data.leadForm,
      facebookPage: data.facebookPage,
      adAccountId: data.adAccountId,
      adCampaignId: data.adCampaignId,
      adSetId: data.adSetId,
      adId: data.adId,
      leadFormId: data.leadFormId,
      facebookPageId: data.facebookPageId,
      brand: data.brand,
      leadIdSocial: data.leadIdSocial,
      businessLeadType: data.businessLeadType,
      platform: data.platform,
      campaignName: data.campaignName,
      adsName: data.adsName,
    });
  }
}
